module.exports = __webpack_public_path__ + "img/fadergs-branco.ea9d9765.svg";